import { render, staticRenderFns } from "./constitution-details.vue?vue&type=template&id=4ee8e7ef&scoped=true&"
import script from "./constitution-details.vue?vue&type=script&lang=js&"
export * from "./constitution-details.vue?vue&type=script&lang=js&"
import style0 from "./constitution-details.vue?vue&type=style&index=0&id=4ee8e7ef&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee8e7ef",
  null
  
)

export default component.exports